export default function objectToArray(input) {
  const result = Object.entries(input).map(([key, value]) => {
    // Check if the value is an object and directly use it, otherwise wrap it with the key
    return typeof value === "object" && value !== null
      ? value
      : { [key]: value };
  });
  return result;
}
